import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Enums } from '@cyborg-monorepo/hunter/common';

@Component({
  template: '' // Empty template since this is just a redirect component
})
export class HuntRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    // Get the hunt from the resolved data
    const hunt = this.route.parent?.snapshot.data['hunt'];
    const id = this.route.parent?.snapshot.paramMap.get('id');
    
    if (!hunt || !id) {
      // Fallback if data isn't available
      this.router.navigate(['/']); 
      return;
    }
    
    // Determine where to redirect based on hunt properties
    let targetRoute: string;
    
    if (hunt.status === Enums.StatusEnum.TO_DO) {
      targetRoute = 'workbench';
    } else if (hunt.editing) {
      targetRoute = 'edit-report';
    } else if (!hunt.editing) {
      targetRoute = 'final-report';
    } else {
      // Default fallback
      targetRoute = 'workbench';
    }
    
    // Navigate to the appropriate child route
    this.router.navigate([targetRoute], { relativeTo: this.route.parent });
  }
}